$(function () {
    let lastScrollTop = 0; // 网页上次滚动的高度
    $(document).on('scroll', function (e) {
        const $this = $(this),
            $navbar = $('.h-navbar');

        if ($this.scrollTop() > $navbar.outerHeight()) {
            $navbar.addClass('fix-top'); // 导航栏完全超出屏幕后改为固定定位 bottom: 100%

            if ($this.scrollTop() > lastScrollTop) {
                $navbar.addClass('hide').removeClass('show'); // 网页向下滚动时，隐藏导航栏
            }

            if (
                $this.scrollTop() < lastScrollTop &&
                ($('.leader-tab-bar-swiper').length === 0 ||
                    !$('.leader-tab-bar-swiper').hasClass('fixed-top'))
            ) {
                $navbar.addClass('show').removeClass('hide'); // 网页向上滚动时，显示导航栏
            }
        }

        if ($this.scrollTop() <= 0) {
            $navbar.removeClass('fix-top show'); // 网页到顶后恢复原样
        }

        lastScrollTop = Math.max(
            Math.min(
                $this.scrollTop(),
                $this.outerHeight() - $(window).outerHeight()
            ),
            0
        ); // 更新滚动高度
    });

    // 阻止滚动穿透
    $('.menu-links--level-1').on('touchmove', function (e) {
        e.preventDefault();
    });

    // 打开菜单
    $('.slide-menu-btn').on('click', function () {
        $('.menu-links--level-1').addClass('active');
        $('.menu-mask').fadeIn(250);
    });

    // 关闭菜单
    $('.menu-close, .menu-mask').on('click', function () {
        $('.menu-links--level-1').removeClass('active');
        $('.menu-mask').fadeOut(250);
    });

    // 打开子菜单
    $('.menu-links--level-1').on(
        'click',
        '[class^=menu-title--level-]',
        function () {
            $(this).siblings('[class^="menu--level-"]').addClass('active');
        }
    );

    // 返回上一级菜单
    $('.menu-links--level-1').on('click', '.menu-back', function () {
        $(this).parent().parent().removeClass('active');
    });

    $('.wechat-hover, .tik-tok-hover').on('mouseenter', function () {
        $(this).siblings('.qrcode').css({
            opacity: 1,
        });
    });

    $('.wechat-hover, .tik-tok-hover').on('mouseleave', function () {
        $(this).siblings('.qrcode').css({
            opacity: 0,
        });
    });
});
